import { styled, Typography } from "@monolith-forensics/monolith-ui";
import { CustomFields } from "./CustomFields";

const StyledContainer = styled.div`
  margin-bottom: 20px;
  .message {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-weight: 400;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
`;

export const EvidenceCustomFields: React.FC<{ customFields: any }> = ({
  customFields,
}) => {
  return (
    <StyledContainer>
      <Typography variant="h3" display="inline">
        Custom Evidence Fields
      </Typography>
      <div className="message">
        Set the enabled option for your custom evidence fields. When enabled,
        the field will be available to the user in Relay when adding evidence to
        a request.
      </div>
      <div
        style={{
          marginTop: 20,
          paddingRight: 20,
          paddingLeft: 5,
        }}
      >
        <CustomFields customFields={customFields} type="evidence" />
      </div>
    </StyledContainer>
  );
};
